import { render, staticRenderFns } from "./Sidepanel.vue?vue&type=template&id=365433ee&scoped=true&"
import script from "./Sidepanel.vue?vue&type=script&lang=js&"
export * from "./Sidepanel.vue?vue&type=script&lang=js&"
import style0 from "./Sidepanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Sidepanel.vue?vue&type=style&index=1&id=365433ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365433ee",
  null
  
)

export default component.exports